import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ConsumerDistributionView } from "../dashboard/ConsumerDistributionView";
import { DashboardHeader } from "../dashboard/DashboardHeader";
import { DistributionTab } from "../dashboard/DistributionTab";
import { PrintingTab } from "../dashboard/PrintingTab";

const Index = () => {
  // Store the active tab in localStorage to persist between visits
  const [activeTab, setActiveTab] = useState<string>("printing");
  const [viewMode, setViewMode] = useState<"cycle" | "consumer">("cycle");
  const [selectedCycle, setSelectedCycle] = useState<string | null>(null);

  const { id } = useParams();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (id) {
      setViewMode("consumer");
      setActiveTab("distribution");
    } else {
      setViewMode("cycle");
    }
  }, [id, location.search, location.pathname, navigate]);

  useEffect(() => {
    if (!id) {
      if (activeTab === "printing" || activeTab === "distribution") {
        setActiveTab(activeTab);
      } else {
        setActiveTab("printing");
      }
    }
  }, [params, id]);

  const handleTabChange = (tab: string) => {
    navigate(`/bx/printing-distribution?tab=${tab}`);
    setViewMode("cycle");
    setSelectedCycle(null);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get("tab");

    if (tabParam && tabParam !== activeTab) {
      setActiveTab(tabParam);
    }
  }, [location.search]);

  const handleBackToCycle = () => {
    setViewMode("cycle");
    navigate(`/bx/printing-distribution?tab=distribution`);
  };

  const handleCycleSelect = (cycle: any) => {
    setSelectedCycle(cycle);
  };

  return (
    <div className="space-y-8">
      <DashboardHeader activeTab={activeTab} onTabChange={handleTabChange} />
      {viewMode === "cycle" ? (
        activeTab === "printing" ? (
          <PrintingTab />
        ) : (
          <DistributionTab onCycleSelect={handleCycleSelect} />
        )
      ) : (
        <ConsumerDistributionView
          cycle={selectedCycle || ""}
          onBack={handleBackToCycle}
        />
      )}
    </div>
  );
};

export default Index;
